import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=375368ca"
import script from "./StockList.vue?vue&type=script&lang=js"
export * from "./StockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('375368ca')) {
      api.createRecord('375368ca', component.options)
    } else {
      api.reload('375368ca', component.options)
    }
    module.hot.accept("./StockList.vue?vue&type=template&id=375368ca", function () {
      api.rerender('375368ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/StockList.vue"
export default component.exports